import { PopoverDesignTokens } from '@primeuix/themes/types/popover';

export const popoverPreset: PopoverDesignTokens = {
  root: {
    borderRadius: '{borderRadius}',
    background: 'var(--background-popup)',
    borderColor: 'var(--divider-normal)',
  },
  colorScheme: {
    dark: {
      root: {
        color: '{nspSlate.0}',
      },
    },
    light: {
      root: {
        color: '{nspSlate.950}',
      },
    },
  },
};
